<nav id="sidebar" class="sidebar-wrapper sidebar-dark bg-light-blue font-montserrat ">
  <div class="sidebar-content">
    <div class="logo sidebar-brand pt-8 pl-[55px]">
      <a routerLink="/home"><img src="assets/images/sidebar-logo.png" height="12" alt="" class="max-w-[140px]"></a>
    </div>

    <ul class=" pt-8" simplebar style="height: calc(100% - 70px);">
      <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
        routerLinkActive="active ms-0" [routerLinkActiveOptions]="{ exact: true }">
        <a [routerLink]="constants.DASHBOARD" (click)="toggleSideBar()" class="flex items-center text-sm">
          <div class="min-w-8 min-h-8 flex items-center justify-center">
            <img src="assets/images/app/sidebar/dashboard-sidebar-unselected.svg" alt="Tournaments" class="w-[15px] h-[15px] me-2" *ngIf="!isActive(constants.DASHBOARD)">
              <img src="assets/images/app/sidebar/dashboard-sidebar-selected.svg" alt="Tournaments" class="w-[15px] h-[15px] me-2" *ngIf="isActive(constants.DASHBOARD)">
          </div>
          Dashboard</a>
      </li>
      @if (isChatEnabled) {
        <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8"
          routerLinkActive="active ms-0">
          <a [routerLink]="constants.CHAT" (click)="toggleSideBar()" class="flex items-center text-sm justify-between w-full">
            <span class="flex items-center">
              <div class="min-w-8 min-h-8 flex items-center justify-center">
                <img src="assets/images/app/sidebar/chat-sidebar-unselected.svg" alt="Chat" class="w-[15px] h-[15px] me-2" *ngIf="!isActive(constants.CHAT)">
                <img src="assets/images/app/sidebar/chat-sidebar-selected.svg" alt="Chat" class="w-[15px] h-[15px] me-2" *ngIf="isActive(constants.CHAT)">
              </div>
              Chat
            </span>
            @if ((chatUnreadCount$ | async) ?? 0; as chatUnreadCount) {
              @if (chatUnreadCount > 0) {
                <span class="bg-indigo-500 text-white text-[10px] font-bold rounded-full w-[18px] h-[18px] flex items-center justify-center leading-none mr-2">
                  {{ chatUnreadCount > 99 ? '99+' : chatUnreadCount }}
                </span>
              }
            }
          </a>
        </li>
      }
      @if(isManagerOrCaptain){
        <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
          <a [routerLink]="constants.LEAGUES" (click)="toggleSideBar()" class="flex items-center text-sm">
            <div class="min-w-8 min-h-8 flex items-center justify-center">
              <img src="assets/images/app/sidebar/league-sidebar-unselected.svg" alt="Leagues" class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.LEAGUES)">
              <img src="assets/images/app/sidebar/league-sidebar-selected.svg" alt="Leagues" class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.LEAGUES)">
            </div>
            Leagues</a>
        </li>
        <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
          <a [routerLink]="constants.GROUNDS" (click)="toggleSideBar()" class="flex items-center text-sm">
            <div class="min-w-8 min-h-8 flex items-center justify-center">
              <img src="assets/images/app/sidebar/ground-sidebar-unselected.svg" alt="Grounds" class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.GROUNDS)">
              <img src="assets/images/app/sidebar/ground-sidebar-selected.svg" alt="Grounds" class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.GROUNDS)">
            </div>
            Grounds</a>
        </li>
        <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
          <a [routerLink]="constants.TOURNAMENTS" (click)="toggleSideBar()" class="flex items-center text-sm">
            <div class="min-w-8 min-h-8 flex items-center justify-center">
              <img src="assets/images/app/sidebar/tournament-sidebar-unselected.svg" alt="Tournaments" class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.TOURNAMENTS)">
              <img src="assets/images/app/sidebar/tournament-sidebar-selected.svg" alt="Tournaments" class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.TOURNAMENTS)">
            </div>
            Tournaments</a>
        </li>
      }
      @if(isShowTournamentButton && !isManagerOrCaptain){
        <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
          <a [routerLink]="constants.TOURNAMENTS" (click)="toggleSideBar()" class="flex items-center text-sm">
            <div class="min-w-8 min-h-8 flex items-center justify-center">
              <img src="assets/images/app/sidebar/tournament-sidebar-unselected.svg" alt="Tournaments" class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.TOURNAMENTS)">
              <img src="assets/images/app/sidebar/tournament-sidebar-selected.svg" alt="Tournaments" class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.TOURNAMENTS)">
            </div>
            Tournaments</a>
        </li>
      }
      <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
        <a [routerLink]="constants.MATCHES" (click)="toggleSideBar()" class="flex items-center text-sm">
          <div class="min-w-8 min-h-8 flex items-center justify-center">
            <img src="assets/images/app/sidebar/match-sidebar-unselected.svg" alt="Matches" class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.MATCHES)">
            <img src="assets/images/app/sidebar/match-sidebar-selected.svg" alt="Matches" class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.MATCHES)">
          </div>
          Matches</a>
      </li>

      <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
        <a [routerLink]="constants.PRACTICES" (click)="toggleSideBar()" class="flex items-center text-sm">
          <div class="min-w-8 min-h-8 flex items-center justify-center">
            <img src="assets/images/app/sidebar/practice-sidebar-unselected.svg" alt="Practices" class="w-[25px] h-[25px] me-2" *ngIf="!isActive(constants.PRACTICES)">
            <img src="assets/images/app/sidebar/practice-sidebar-selected.svg" alt="Practices" class="w-[25px] h-[25px] me-2" *ngIf="isActive(constants.PRACTICES)">
          </div>
          Practices</a>
      </li>

      <li *ngIf="isManagerOrCaptain" class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
        <a [routerLink]="constants.PLAYERS" (click)="toggleSideBar()" class="flex items-center text-sm">
          <div class="min-w-8 min-h-8 flex items-center justify-center">
            <img src="assets/images/app/sidebar/player-sidebar-unselected.svg" alt="Players" class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.PLAYERS)">
            <img src="assets/images/app/sidebar/player-sidebar-selected.svg" alt="Players" class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.PLAYERS)">
          </div>
          Players</a>
      </li>

      <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
        <a (click)="toggleSubmenu('finances')" class="flex items-center text-sm cursor-pointer">
          <div class="min-w-8 min-h-8 flex items-center justify-center">
            <img src="assets/images/app/sidebar/expenses-sidebar-unselected.svg" alt="Finances" class="w-[20px] h-[20px] me-2" *ngIf="!isFinancesActive()">
            <img src="assets/images/app/sidebar/expenses-sidebar-selected.svg" alt="Finances" class="w-[20px] h-[20px] me-2" *ngIf="isFinancesActive()">
          </div>
          Finances
          <svg class="w-4 h-4 ml-auto transition-transform" [class.rotate-180]="financesOpen" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </a>
        <div class="sidebar-submenu" [ngClass]="{'block': financesOpen}">
          <ul class="list-none m-0 pl-10 py-1">
            @if (isExpenseEnabled || isExpenseEnabledGlobally) {
              <li>
                <a [routerLink]="['/' + constants.EXPENSES]" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">Expenses</a>
              </li>
            }
            <li>
              <a [routerLink]="['/' + constants.FEE_PAYMENTS]" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">Fees &amp; Payments</a>
            </li>
          </ul>
        </div>
      </li>

      <!-- <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0" [routerLinkActiveOptions]="{ exact: true }">
        <a [routerLink]="constants.NOTICEBOARD + '/' + constants.NB_INDEX"
          (click)="toggleSubmenu(constants.NOTICEBOARD + '/' + constants.NB_INDEX)">
          <i class="uil uil-chart-line w-[20px] h-[20px] me-2"></i>Notice Board
        </a>
        <div class="sidebar-submenu"
          [ngClass]="{'block ms-0': manuOpen === ('/' + constants.NOTICEBOARD + '/' + constants.NB_INDEX) || manuOpen === ('/' + constants.NOTICEBOARD + '/' + constants.GALLERY)}">
          <ul>
            <li [ngClass]="manuOpen === (constants.NOTICEBOARD + '/' + constants.NB_INDEX) ? 'active ms-0' : ''">
              <a [routerLink]="constants.NOTICEBOARD + '/' + constants.NB_INDEX" routerLinkActive="active ms-0"
                [routerLinkActiveOptions]="{ exact: true }">
                Feed
              </a>
            </li>
            <li [ngClass]="manuOpen === (constants.NOTICEBOARD + '/' + constants.GALLERY) ? 'active ms-0' : ''">
              <a [routerLink]="constants.NOTICEBOARD + '/' + constants.GALLERY" routerLinkActive="active ms-0"
                [routerLinkActiveOptions]="{ exact: true }">
                Gallery
              </a>
            </li>
          </ul>
        </div>
      </li> -->
      @if (isManager) {
        <li class="sidebar-dropdown hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
          <a (click)="toggleSubmenu('settings')" class="flex items-center text-sm cursor-pointer">
            <div class="min-w-8 min-h-8 flex items-center justify-center">
              <img src="assets/images/app/sidebar/settings-sidebar-unselected.svg" alt="Settings" class="w-[20px] h-[20px] me-2" *ngIf="!isActive(constants.SETTINGS)">
              <img src="assets/images/app/sidebar/settings-sidebar-selected.svg" alt="Settings" class="w-[20px] h-[20px] me-2" *ngIf="isActive(constants.SETTINGS)">
            </div>
            Settings
            <svg class="w-4 h-4 ml-auto transition-transform" [class.rotate-180]="settingsOpen" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </a>
          <div class="sidebar-submenu" [ngClass]="{'block': settingsOpen}">
            <ul class="list-none m-0 pl-10 py-1">
              <li>
                <a [routerLink]="['/' + constants.SETTINGS + '/general']" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">General</a>
              </li>
              @if (isTreasurer) {
                <li>
                  <a [routerLink]="['/' + constants.SETTINGS + '/fees']" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">Fees</a>
                </li>
              }
              @if (isTreasurer && (isExpenseEnabled || isExpenseEnabledGlobally) && isProOrAbove) {
                <li>
                  <a [routerLink]="['/' + constants.SETTINGS + '/expense-config']" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">Expenses</a>
                </li>
              }
              <li>
                <a [routerLink]="['/' + constants.SETTINGS + '/permission']" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">Permission</a>
              </li>
              @if (isManager && hasFeatureFlags) {
                <li>
                  <a [routerLink]="['/' + constants.SETTINGS + '/features']" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">Features</a>
                </li>
              }
              @if (isManager) {
                <li>
                  <a [routerLink]="['/' + constants.SETTINGS + '/subscription']" routerLinkActive="active" (click)="toggleSideBar()" class="block py-1 text-xs">Subscription</a>
                </li>
              }
            </ul>
          </div>
        </li>
      }
      <!-- Help Center -->
      <li class="hover:bg-light-sky transition duration-500 ease-in-out new-sidebar-li p-2 ml-0 pl-8" routerLinkActive="active ms-0">
        <a [href]="helpCenterUrl" target="_blank" rel="noopener noreferrer" (click)="toggleSideBar()" class="flex items-center text-sm">
          <div class="min-w-8 min-h-8 flex items-center justify-center">
            <svg class="w-[20px] h-[20px] me-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
            </svg>
          </div>
          Help Center
        </a>
      </li>
      <!-- Plan Badge (CRT-507) -->
      @if (clubSubscription && planBadgeLabel) {
        <li class="p-2 pl-8 mt-2">
          <a [routerLink]="['/' + constants.SETTINGS + '/subscription']" (click)="toggleSideBar()"
            class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[11px] font-medium cursor-pointer transition-colors hover:opacity-80"
            [ngClass]="planBadgeClass">
            <svg class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456z" />
            </svg>
            {{ planBadgeLabel }} Plan
          </a>
        </li>
      }
    </ul>
    <!-- sidebar-menu  -->
  </div>
</nav>
